import { connect } from 'react-redux';
import PodcastFromView from './index'
import {loadPodcasts, savePodcast, updatePodcast} from '../../actions/Podcasts'
import { formValueSelector } from 'redux-form'

const mapStateToProps = (state, props) => {
    return {
	getFormValue: (name) => {
	    return formValueSelector('podcast')(state, name)
	}
    }
}

const mapDispatchToProps = (dispatch, state) => {    
    return {
	savePodcast: (data) => {
	    return dispatch(savePodcast(data)).then(() =>  dispatch(loadPodcasts()))
	},
	updatePodcast: (data) => {
	    return dispatch(updatePodcast(data)).then(() =>  dispatch(loadPodcasts()))
	}
    }
}

const PodcastFromContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PodcastFromView);




export default PodcastFromContainer;



// WEBPACK FOOTER //
// ./src/components/PodcastForm/Container.js